export default "__VITE_ASSET__CbLjS8Vp__"